import axios from 'axios';

import { createApiError } from '@/api/utils/error';

export type SortData = {
	id: number;
	title: string;
	title_en: string;
};

/** Апи получения списка сортов */
export const getSorts = async (): Promise<SortData[]> => {
	try {
		const { data } = await axios.get(`${process.env.HOST}/api_v1/sorts/`);
		return data;
	} catch (error) {
		throw createApiError(error, 'Ошибка получения сортов');
	}
};
